//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import SectionWithFilter from '../../components/SectionWithFilter.vue'
import StocksDebitsTab from '../../pages/main/sections/Stock/StocksDebitsTab.vue'

export default {
  name: 'StockCardSectionDebits',
  components: {
    SectionWithFilter,
    StocksDebitsTab
  },
  props: {
    config: {
      type: Object,
      required: true
    },
    objectSrc: {
      type: Object,
      default: null
    }
  },
  data: () => {
    const formId = 'stockCardDebits'

    return {
      formId: formId,

      filterConfig: {
        filterName: 'ФИЛЬТР ОСТАТКОВ НА СКЛАДАХ',
        filterType: 'stockDebits',
        filterFormId: formId,
        filterUnavailable: false
      }
    }
  },
  computed: {
    objectId: function () {
      return this.objectSrc && this.objectSrc.id || null
    }
  },
  watch: {
    objectSrc: {
      handler: function (object) {
        this.onObjectChanged(object)
      },
      immediate: true
    }
  },
  methods: {
    onObjectChanged: function (object) {
      const tabComponent = this.$refs.tabComponent
      if (tabComponent && tabComponent.onUpdate) {
        tabComponent.onUpdate()
      }
    }
  }
}
